<mat-card class="fx-row fw-wrap p-16 gap-40">
  <div class="fx-row justify-content-between summary gap-20">

    <div class="fx-column gap-5 name">
      <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.NAME' | translate }}</span>
      <span class="text bold">{{ name() }}</span>
    </div>

    @if (url()) {
      <div class="fx-column gap-5 url">
        <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.URL' | translate }}</span>
        <a [href]="url()" target="_blank" class="bold">{{ url() }}</a>
      </div>
    }

    @if (status()) {
      <div class="fx-column gap-5 status">
        <span class="small upper light bold">{{ 'INTEGRATIONS.STATUS' | translate }}</span>
       <app-crawl-status [status]="status()"></app-crawl-status>
      </div>
    }

    <div class="fx-column gap-5 frequency">
      <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.FREQUENCY' | translate }}</span>
      <span class="bold">{{ frequencyLabel() }}</span>
    </div>

    @if (countries().length > 0) {
      <div class="fx-column gap-5 countries">
        <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.COUNTRIES' | translate }}</span>
        <div class="fx-row align-items-center gap-5">
          <app-document-countries class="h-5" [territories]="territories()"></app-document-countries>
        </div>
      </div>
    }

    @if (searchDepth() !== undefined) {
      <div class="fx-column gap-5 search-depth">
        <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.SEARCH_DEPTH' | translate }}</span>
        <span class="bold">{{ searchDepth() }}</span>
      </div>
    }

    @if (maxPages() !== undefined) {
      <div class="fx-column gap-5 max-pages">
        <span class="small upper light bold">{{ 'INTEGRATIONS.FIELDS.MAX_PAGES' | translate }}</span>
        <span class="bold">{{ maxPages()?.toLocaleString() }} {{ 'INTEGRATIONS.FIELDS.PAGE_UNIT' | translate }}</span>
      </div>
    }
  </div>
</mat-card>
